<template>
  <div id="dashboard-orders">
    <v-card
      class="px-5 py-2 mt-4 mb-0 elevation-0"
      :class="{ 'sticky-filters': user.preferences.stickyFilters }"
    >
      <CommonFilters type="order" :hide="['type']" @filterElements="filterElements" />
    </v-card>

    <SomePositionIncomplete />

    <v-row>
      <v-col cols="12" lg="12" md="12" class="mt-4 py-0">
        <OrdersProfit ref="ordersProfit" />
      </v-col>
      <v-col cols="12" lg="12" md="12" class="mt-4 py-0">
        <OrdersProfitByMonth ref="ordersProfitByMonth" />
      </v-col>
      <v-col cols="12" lg="12" md="12" class="mt-4 py-0">
        <OrdersProfitByPosition ref="ordersProfitByPosition" />
      </v-col>
      <v-col cols="12" lg="12" md="12" class="mt-4 py-0">
        <OrdersProfitByPositionType ref="ordersProfitByPositionType" />
      </v-col>
      <v-col cols="12" lg="12" md="12" class="mt-4 py-0">
        <OrdersByMonth ref="buyOrdersByMonth" type="buy" />
      </v-col>
      <v-col cols="12" lg="12" md="12" class="mt-4 py-0">
        <OrdersByMonth ref="sellOrdersByMonth" type="sell" />
      </v-col>
      <v-col cols="12" lg="12" md="12" class="mt-4 py-0">
        <OrdersByPosition ref="buyOrdersByPosition" type="buy" />
      </v-col>
      <v-col cols="12" lg="12" md="12" class="mt-4 py-0">
        <OrdersByPosition ref="sellOrdersByPosition" type="sell" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CommonFilters from '@/views/components/common/CommonFilters'
import OrdersProfit from '@/views/components/dashboardDetail/orders/OrdersProfit'
import OrdersProfitByMonth from '@/views/components/dashboardDetail/orders/OrdersProfitByMonth'
import OrdersProfitByPosition from '@/views/components/dashboardDetail/orders/OrdersProfitByPosition'
import OrdersProfitByPositionType from '@/views/components/dashboardDetail/orders/OrdersProfitByPositionType'
import OrdersByPosition from '@/views/components/dashboardDetail/orders/OrdersByPosition'
import OrdersByMonth from '@/views/components/dashboardDetail/orders/OrdersByMonth'
import SomePositionIncomplete from '@/views/components/common/positions/SomePositionIncomplete.vue'

export default {
  components: {
    CommonFilters,
    OrdersProfit,
    OrdersProfitByMonth,
    OrdersProfitByPosition,
    OrdersProfitByPositionType,
    OrdersByPosition,
    OrdersByMonth,
    SomePositionIncomplete,
  },
  computed: {
    ...mapState(['user']),
  },
  methods: {
    async filterElements(filters) {
      try {
        if (this.$refs.ordersProfit) this.$refs.ordersProfit.loadSummary(filters)
        if (this.$refs.ordersProfitByMonth) this.$refs.ordersProfitByMonth.loadSummary(filters)
        if (this.$refs.ordersProfitByPosition)
          this.$refs.ordersProfitByPosition.loadSummary(filters)
        if (this.$refs.ordersProfitByPositionType)
          this.$refs.ordersProfitByPositionType.loadSummary(filters)
        if (this.$refs.buyOrdersByMonth) this.$refs.buyOrdersByMonth.loadSummary(filters)
        if (this.$refs.sellOrdersByMonth) this.$refs.sellOrdersByMonth.loadSummary(filters)
        if (this.$refs.buyOrdersByPosition) this.$refs.buyOrdersByPosition.loadSummary(filters)
        if (this.$refs.sellOrdersByPosition) this.$refs.sellOrdersByPosition.loadSummary(filters)
      } catch (error) {
        this.$root.$snackbar.checkAndOpenCommonLoadError(error)
      }
    },
  },
}
</script>
